import styles from "./AdvertBanner.module.css"

const AdvertBanner = () => {
    return (
        <div className={styles.outCont}>
            <div className={styles.innerCont}>
                <div className="adfinity_block_15751"></div>
            </div> 
        </div>
    );
}

export default AdvertBanner;